<div
  class="canvas-element"
  [class.clickable]="!!el().isClickable"
  [class.draggable]="!!el().draggable"
  [class.snapped]="!!el().draggable?.isSnapped"
  [style]="{
    position: 'absolute',
    width: '100%',
    height: '100%',
    cursor: isDragging() ? 'grabbing' : !!el().draggable ? 'grab' : el().isClickable ? 'pointer' : 'default',
    pointerEvents: isDragging() ? 'none' : undefined,
  }"
  (click)="clicked.emit()"
>
  <div
    class="scalar"
    [style]="{
      position: 'absolute',
      width: '100%',
      height: '100%',
      transformOrigin: el().pivot[0] * 100 + '% ' + el().pivot[1] * 100 + '%',
      scale: isDragging() && !el().draggable?.isSnapped ? 1.2 : undefined,
      rotate: el().rotation ? el().rotation + 'deg' : undefined,
      filter: isDragging() && !el().draggable?.isSnapped ? 'drop-shadow(0 0 10px rgba(0,0,0,0.5))' : undefined,
      transition: 'scale 0.1s ease-out, rotate 0.1s ease-out, filter 0.1s ease-out',
    }"
  >
    @let visual = el().visual;
    @if (visual) {
      @if (visual.type === 'DEBUG') {
        <app-debug-rect style="width: 100%; height: 100%" />
      } @else if (visual.type === 'IMAGE') {
        <app-visual-element [url]="visual.url" [fit]="visual.fit" [color]="visual.color" />
      } @else if (visual.type === 'COLOR') {
        <div style="width: 100%; height: 100%" [style.background]="visual.color"></div>
      }
    }
    @let text = el().text;
    @if (text) {
      <div style="position: absolute; display: grid; place-items: center" [style]="getStyle(text)">
        <app-style-sheet-sprite [sprite]="_stylesService.LABEL_PANEL()?.container" [text]="_stylesService.LABEL_PANEL()?.text">
          <div style="width: 100%; height: 100%; place-content: center">
            <lp-text [text]="text.text" />
          </div>
        </app-style-sheet-sprite>
      </div>
    }
  </div>
</div>
